<template>
<div class="slide slide01">
    <div class="tableBox">
        <table class="table">
            <tbody>
                <tr class="first">
                    <th>Finance</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client01.png" alt="메리츠화재"></li>
                            <li class="no2"><img src="@/assets/images/client02.png" alt="DB손해보험"></li>
                            <li class="no3"><img src="@/assets/images/client03.png" alt="빗썸"></li>
                            <li class="no4"><img src="@/assets/images/client04.png" alt="어니스트펀드"></li>
                            <li class="no5"><img src="@/assets/images/client05.png" alt="신한은행"></li>
                        </ul>
                    </td>
                </tr>
                <tr class="two">
                    <th>Shopping</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client06.png" alt="현대H몰"></li>
                            <li class="no2"><img src="@/assets/images/client07.png" alt="위페프"></li>
                            <li class="no3"><img src="@/assets/images/client08.png" alt="LF몰"></li>
                            <li class="no4"><img src="@/assets/images/client09.png" alt="GSshop"></li>
                        </ul>
                    </td>
                </tr>
                <tr class="three">
                    <th>O2O</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client10.png" alt="마켓컬리"></li>
                            <li class="no2"><img src="@/assets/images/client11.png" alt="쏘카"></li>
                            <li class="no3"><img src="@/assets/images/client12.png" alt="타다"></li>
                            <li class="no4"><img src="@/assets/images/client13.png" alt="SK엔카"></li>
                        </ul>
                    </td>
                </tr>
                <tr class="four">
                    <th>Education <br>&amp; Medical</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client14.png" alt="파고다어학원"></li>
                            <li class="no2"><img src="@/assets/images/client15.png" alt="YBM"></li>
                            <li class="no3"><img src="@/assets/images/client16.png" alt="자생한방병원"></li>
                            <li class="no4"><img src="@/assets/images/client17.png" alt="바노바기성형외과의원"></li>
                        </ul>
                    </td>
                </tr>
                <tr class="five">
                    <th>Beauty <br>&amp; Apparel</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client18.png" alt="제이에스티나"></li>
                            <li class="no2"><img src="@/assets/images/client19.png" alt="르꼬끄"></li>
                            <li class="no3"><img src="@/assets/images/client20.png" alt="아식스"></li>
                            <li class="no4"><img src="@/assets/images/client21.png" alt="니베아"></li>
                        </ul>
                    </td>
                </tr>
                <tr class="six">
                    <th>Service</th>
                    <td>
                        <ul class="clientList">
                            <li class="no1"><img src="@/assets/images/client22.png" alt="듀오"></li>
                            <li class="no2"><img src="@/assets/images/client23.png" alt="알바천국"></li>
                            <li class="no3"><img src="@/assets/images/client24.png" alt="NGO"></li>
                            <li class="no4"><img src="@/assets/images/client25.png" alt="굿네이버스"></li>
                            <li class="no5"><img src="@/assets/images/client26.png" alt="옥스팜"></li>
                            <li class="no6"><img src="@/assets/images/client27.png" alt="컴패션"></li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
<script>
export default {

}
</script>